<template>
  <el-dialog
    title="业务单元"
    width="500px"
    :visible="showChooseBizUnitDialog"
    @close="handleClose"
    v-loading="dialogLoading"
  >
    <el-form>
      <el-row>
        <el-col :span="12" :offset="1">
          <el-form-item prop="tenantGuid" label-width="80px">
            <div slot="label">
              <span style="color: red">*</span>
              指派公司
            </div>
            <el-select
              placeholder="请选择"
              filterable
              class="w300"
              @change="onChangetenant"
              :value="serviceTenantGuid"
            >
              <el-option
                v-for="item in serviceTenants"
                :key="item.guid"
                :label="item.tenantName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="1">
          <el-form-item prop="tenantGuid" label-width="80px">
            <div slot="label">核算单元</div>
            <el-select
              placeholder="请选择"
              filterable
              class="w300"
              multiple
              @change="onChangeBizUnit"
              :value="ruleForm.bizUnitGuid"
            >
              <el-option
                v-for="item in bizUnitNameOptions"
                :key="item.guid"
                :label="item.label"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mixins from "./mixins/detailMixins.js";

export default {
  mixins: [mixins],
  name: "ChooseBizUnitDialog",
  props: {
    serviceTenants: {
      type: Array,
      default: [],
    },
    serviceTenantGuid: {
      type: String,
      default: "",
    },
    showChooseBizUnitDialog: {
      type: Boolean,
      default: false,
    },
    dialogLoading: {
      type: Boolean,
      default: false,
    },
    ruleForm: {
      type: Object,
      default: () => ({
        bizUnitGuid: "",
      }),
    },
    bizUnitNameOptions: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  methods: {
    handleSubmit() {
      this.$emit("submit");
    },
    handleClose() {
      this.$emit("close");
    },
    onChangetenant(val) {
      this.$emit("changeBizUnitTenant", val);
    },
    onChangeBizUnit(val) {
      this.$emit("changeBizUnit", val);
    },
  },
  created() {},
};
</script>

<style lang="less" scoped></style>
